import IMAGES from '../../../constants/images';

const styles = (theme) => ({
    navLink: {
        color: theme.palette.primary.main,
    },
    title: {
        fontSize: '24px',
        lineHeight: 1.1,
        fontWeight: 600,
        color: theme.custom.textDarkSecondaryColor,
    },
    container: {
        fontFamily: `'effra',sans-serif`,
    },
    header: {
        paddingBottom: '20px',
    },
    activeChallengeCover: {
        height: '351px',
        borderRadius: '5px',
        // opacity: '0.66',
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${IMAGES.defaultActiveChallengeBg})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: '50% 50%',
        position: 'relative',
    },
    activeChallengeCoverHeader: {
        padding: '10px',
        flexWrap: 'nowrap',
        height: '100%',
        width: '100%',
    },
    editCover: {
        borderColor: theme.palette.primary.main,
        borderStyle: 'solid',
        border: '2px',
        fontWeight: 600,
        backgroundColor: theme.palette.white.main,
        '&:hover': {
            color: theme.palette.primary.dark,
            borderColor: theme.palette.primary.dark,
            backgroundColor: theme.palette.white.main,
        },
    },
    buttonIcon: {
        marginRight: '5px',
    },
    activeChallengeCoverBodyRow: {
        height: '100%',
    },
    activeChallengeCoverBodyHeader: {
        height: '50px',
    },
    activeChallengeCoverBodyRowFooter: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignContent: 'stretch',
        justifyContent: 'flex-start',
        height: '100px',
        alignItems: 'flex-end',
        padding: '10px',
    },
    activeChallengeCoverBodyRowMiddle: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignContent: 'stretch',
        justifyContent: 'flex-start',
        height: '250px',
        alignItems: 'flex-end',
        padding: '10px',
    },
    challengeMeta: {
        width: '100%',
    },
    challengePeopleMeta: {
        width: '200px',
        padding: '15px',
    },
    challengeTitleWrapper: {
        padding: '0 10px',
    },
    challengeTitle: {
        fontSize: '24px',
        lineHeight: 1.1,
        fontWeight: 600,
        color: theme.palette.white.main,
    },
    challengeDates: {
        color: theme.palette.white.main,
        padding: '10px 10px 0px 10px',
    },
    peopleIcon: {
        width: '45px',
        height: '45px',
        '& svg': {
            fill: theme.palette.white.main,
            fontSize: '30px',
        },
    },
    challengeText: {
        color: theme.palette.white.main,
    },
    loadingIndicator: {
        position: 'absolute',
        top: '50%',
        width: '100%',
        textAlign: 'center',
        color: theme.palette.white.main,
    },
});

export default styles;
